import AppointmentsSagas from '../appointments/sagas.js';
import PrescriptionsSagas from '../prescriptions/sagas.js';
import OrderSagas from './orders.js';
import PageViewSagas from './pageview.js';
import PasswordChangeSagas from './passwordChange.js';
import MyProfileSagas from './profileEdit.js';

var dataLayerSagas = [
    ...PageViewSagas,
    ...MyProfileSagas,
    ...PasswordChangeSagas,
    ...OrderSagas,
    ...AppointmentsSagas,
    ...PrescriptionsSagas, 
];

export { dataLayerSagas as default };
//# sourceMappingURL=index.js.map
